let listeners = [];

let loading = false;

export function setLoading(value) {
  loading = value;
  listeners.forEach(cb => cb(loading));
}

export function subscribe(callback) {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter(l => l !== callback);
  };
}
